import { format } from 'date-fns';
import axios from 'services/api';
import { API2_HOST } from '../../helpers/urlHelper';
import { baseGetWithoutParam } from 'services/base-services/baseService';

const API_BASE_URL = `${API2_HOST}/ev-booking`;

const getBays = async () => {
  return await baseGetWithoutParam(`${API_BASE_URL}/bays`);
};

const fetchUserHistory = async (user, from, to) => {
  const params = {
    from: format(from, 'yyyy-MM-dd'),
    to: format(to, 'yyyy-MM-dd'),
    user: user
  };

  try {
    const response = await axios.get(`${API_BASE_URL}/request`, { params });
    if (response.data && response.data.success) {
      return response.data.data.map(item => ({
        bayNo: item.bayNo,
        id: item.id,
        requestedBy: item.requestedBy,
        site: item.site,
        bookingDate: new Date(item.bookingDate),
        slotType: item.slotType,
        status: item.status,
        processedBy: item.processedBy,
        processedAt: item.processedAt ? new Date(item.processedAt) : null,
        notes: item.notes,
        created: new Date(item.created)
      }));
    } else if (!response.data.success) {
      return [];
    } else {
      throw new Error(response.data.message || 'Failed to fetch requests.');
    }
  } catch (error) {
    console.error('API Error fetching history:', error);
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        'Unknown error occurred.'
    );
  }
};

const fetchAllRequests = async (from, to) => {
  const params = {
    from: format(from, 'yyyy-MM-dd'),
    to: format(to, 'yyyy-MM-dd')
  };
  try {
    const response = await axios.get(`${API_BASE_URL}/request`, { params });
    if (response.data && response.data.success) {
      return response.data.data.map(item => ({
        ...item,
        bookingDate: new Date(item.bookingDate),
        created: new Date(item.created),
        processedAt: item.processedAt ? new Date(item.processedAt) : null
      }));
    } else if (!response.data.success) {
      return [];
    } else {
      throw new Error(response.data.message || 'Failed to fetch requests.');
    }
  } catch (error) {
    console.error('API Error fetching requests:', error);
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        'Unknown error occurred while fetching requests.'
    );
  }
};

const fetchAllUsers = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user`);
    if (response.data && response.data.success) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || 'Failed to fetch user list.');
    }
  } catch (error) {
    console.error('API Error fetching user list:', error);
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        'Unknown error occurred while fetching user list.'
    );
  }
};

const createRequest = async requestPayloadArray => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/request`,
      requestPayloadArray
    );

    if (response.data && response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Failed to submit request.');
    }
  } catch (error) {
    console.error('API Error submitting request:', error);
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        'Unknown error occurred.'
    );
  }
};

const updateRequestStatus = async (requestId, status, processedBy) => {
  const payload = {
    requestId,
    status,
    processedBy
  };

  try {
    const response = await axios.patch(`${API_BASE_URL}/request`, payload);

    if (response.data && response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Failed to update status.');
    }
  } catch (error) {
    console.error('API Error updating status:', error);
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        'Unknown error occurred.'
    );
  }
};

const updateEVUserInfo = async (userId, userName, site, plateNo, isActive) => {
  const payload = {
    userId,
    userName,
    site,
    plateNo,
    isActive
  };

  try {
    const response = await axios.patch(`${API_BASE_URL}/user`, payload);

    if (response.data && response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Failed to update status.');
    }
  } catch (error) {
    console.error('API Error updating status:', error);
    throw new Error(
      error.response?.data?.message ||
        error.message ||
        'Unknown error occurred.'
    );
  }
};

export {
  fetchUserHistory,
  fetchAllRequests,
  fetchAllUsers,
  createRequest,
  updateRequestStatus,
  updateEVUserInfo,
  getBays
};
